import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'

// const firebaseConfig = {
//   apiKey: "AIzaSyCmwBvjqe7iClfDz9Xj8ryJrVTK4qyD_Z8",
//   authDomain: "mytube-100.firebaseapp.com",
//   projectId: "mytube-100",
//   storageBucket: "mytube-100.appspot.com",
//   messagingSenderId: "727853781567",
//   appId: "1:727853781567:web:397c5d5ed25f3f05841e8a"
// };

const firebaseConfig = {
  apiKey: "AIzaSyCwIHFYCAzisWCJUBjYo_MJa1xJoXM2d7c",
  authDomain: "mytube-150.firebaseapp.com",
  projectId: "mytube-150",
  storageBucket: "mytube-150.appspot.com",
  messagingSenderId: "411889902253",
  appId: "1:411889902253:web:7d7e6f18a5a69d49d0dc24"
};

//using firsbase initializer
firebase.initializeApp(firebaseConfig)

export default firebase.auth()